// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m360-relative-section{position:relative}.m360-video-bg{position:absolute;width:100%;height:100%;background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = exports;
